import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from '@app/shared/shared.module';
import { ToastOptions } from '@app/constants';
import { CoreModule } from '@app/core/core.module';
import { SharedService } from './shared/services/shared.service';
import { AppRoutesModule } from './app.routes';
import { AppComponent } from './app.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AuthModule } from '@delhivery/auth';
import { AUTH_CONFIG } from '@env/environment';
import { CookieModule } from 'ngx-cookie';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    ToastrModule.forRoot(ToastOptions),
    // Must stay above AuthModule so its 'lib-user-profile' redirect wins over the library's
    // own route (profile editing is intentionally not offered). AppRoutesModule defines
    // 'lib-auth-oauth-callback' itself, so its '**' route doesn't affect login.
    AppRoutesModule,
    AuthModule.forRoot({
      clientId: AUTH_CONFIG.clientId,
      default_issuer: AUTH_CONFIG.issuer,
      landing_page: AUTH_CONFIG.landingPage
    }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CookieModule.forRoot()
  ],
  providers: [
    Title,
    SharedService,
    // Default every mat-form-field to the outlined appearance so the whole app
    // matches the boxed look from the legacy Angular 7 build.
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
